import { render, staticRenderFns } from "./UnidadeConservacaoUs.vue?vue&type=template&id=00f66e65&lang=pug"
import script from "./UnidadeConservacaoUs.vue?vue&type=script&lang=js"
export * from "./UnidadeConservacaoUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports